import Swiper from "swiper";
import { Pagination, A11y } from "swiper/modules";

import "swiper/swiper.css";

Swiper.use([Pagination, A11y]);

const testimonials = new Swiper(".testimonials", {
  slidesPerView: 1,
  spaceBetween: 24,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

/**
 *
 * Modal
 *
 */

const modal = document.getElementById("modal");
const modalButton = document.getElementById("modal-button");

modalButton.addEventListener("click", function () {
  modal.classList.add("hidden");
});

document.addEventListener("keydown", function (event) {
  if (event.key === "Escape") {
    modal.classList.add("hidden");
  }
});
